import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import Countdown from 'react-countdown';
import styles from './count_down.module.scss';

const CountDown: React.FC = () => {
  const { event } = useContext(EventDetailsContext);

  // Add leading zeros to numbers (01, 02, etc.)
  const padZero = (num: number) => String(num).padStart(2, '0');

  // Render a custom countdown
  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div
        className={
          `${styles.countdownContainer} d-flex justify-content-center align-items-center gap-3 pb-0`
        }
        data-testid='count-down'
      >
        {days > 0 && (
          <div data-testid='count-down-days' className={`${styles.countdownBox} text-center`}>
            <div className={styles.countdownValue}>{padZero(days)}</div>
            <div className={styles.countdownLabel}>Days</div>
          </div>
        )}
        {(days > 0 || hours > 0) && (
          <div data-testid='count-down-hours' className={`${styles.countdownBox} text-center`}>
            <div className={styles.countdownValue}>{padZero(hours)}</div>
            <div className={styles.countdownLabel}>Hours</div>
          </div>
        )}
        {(days > 0 || hours > 0 || minutes > 0) && (
          <div data-testid='count-down-minutes' className={`${styles.countdownBox} text-center`}>
            <div className={styles.countdownValue}>{padZero(minutes)}</div>
            <div className={styles.countdownLabel}>Minutes</div>
          </div>
        )}
        {(days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (
          <div data-testid='count-down-seconds' className={`${styles.countdownBox} text-center`}>
            <div className={styles.countdownValue}>{padZero(seconds)}</div>
            <div className={styles.countdownLabel}>Seconds</div>
          </div>
        )}
      </div>
    );
  };

  return <Countdown date={event?.starts_at} renderer={renderer} />;
};

export default CountDown;
